"use client";

import { c as _c } from "react/compiler-runtime";
import { AccessibilityNew, Facebook, Instagram } from "@mui/icons-material";
import Image from "next/image";
import Link from "next/link";
import React, { useState } from "react";
import styled from "styled-components";
import { Text, TextColor, TextSize, TextWeight } from "../../components/Text";
import paynow from "./paynow.png";
const TriangleIcon = styled.div`
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: ${props => props.$expanded ? "6px solid black" : "none"};
  border-bottom: ${props => !props.$expanded ? "6px solid black" : "none"};
  transition: transform 0.3s ease;
  transform: ${props => props.$expanded ? "rotate(0deg)" : "rotate(-180deg)"};
`;

// Add a styled component for the animated content
const AnimatedContent = styled.div`
  max-height: ${props => props.$expanded ? props.$height : "0"};
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
  opacity: ${props => props.$expanded ? "1" : "0"};
  transition-property: max-height, opacity;
  transition-duration: 0.3s;
  transition-timing-function: ease-in-out;
`;
const CustomLi = styled.li`
  p {
    &:hover {
      color: ${({
  theme
}) => theme.colors.GRAYSCALE_900};
      text-decoration: underline;
    }
  }
`;
const StyledSocialMediaLink = styled(Link)`
  svg {
    &:hover {
      color: ${({
  theme
}) => theme.colors.GRAYSCALE_400};
    }
  }
`;
const StyledAccessibility = styled.div`
  cursor: pointer;

  svg {
    &:hover {
      color: ${({
  theme
}) => theme.colors.GRAYSCALE_400};
    }
  }
`;
export const Footer = t0 => {
  const $ = _c(26);
  const {
    linkBlocks,
    isLoading,
    isLoggedIn,
    setHideButton
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [expandedSections, setExpandedSections] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = id => {
      setExpandedSections(prev => ({
        ...prev,
        [id]: !prev[id]
      }));
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const toggleSection = t2;
  if (isLoading) {
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <FooterSkeleton />;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    return t3;
  }
  let t3;
  if ($[3] !== expandedSections || $[4] !== isLoggedIn || $[5] !== linkBlocks) {
    let t4;
    if ($[7] !== isLoggedIn) {
      t4 = block => !isLoggedIn ? block.title !== "Konto u\u017Cytkownika" : true;
      $[7] = isLoggedIn;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    let t5;
    if ($[9] !== expandedSections) {
      t5 = block_0 => <div key={block_0.id} className="mb-8"><div className="flex justify-between items-center md:block cursor-pointer md:cursor-default" onClick={() => toggleSection(block_0.id)}><Text text={block_0.title} weight={TextWeight.BOLD} textTransform="uppercase" className="tracking-widest" color={TextColor.BLACK} fontSize={TextSize.XS} /><TriangleIcon $expanded={expandedSections[block_0.id] || false} className="md:hidden" /></div><div className="hidden md:block"><ul className="space-y-2 mt-4">{block_0.links.map(_temp)}</ul></div><div className="md:hidden"><AnimatedContent $expanded={expandedSections[block_0.id] || false} $height="200px"><ul className="space-y-2 mt-4">{block_0.links.map(_temp2)}</ul></AnimatedContent></div></div>;
      $[9] = expandedSections;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    t3 = linkBlocks.filter(t4).map(t5);
    $[3] = expandedSections;
    $[4] = isLoggedIn;
    $[5] = linkBlocks;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[11] !== t3) {
    t4 = <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">{t3}</div>;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <StyledSocialMediaLink href="https://www.facebook.com/carryworld/" target="_blank" rel="noopener noreferrer" title="Facebook Carry World"><Facebook /></StyledSocialMediaLink>;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <StyledSocialMediaLink href="https://www.instagram.com/carrypolska/" target="_blank" rel="noopener noreferrer" title="Instagram Carry Polska"><Instagram /></StyledSocialMediaLink>;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== setHideButton) {
    t7 = () => {
      localStorage.setItem("carry-hide-button", "false");
      setHideButton(false);
    };
    $[15] = setHideButton;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <AccessibilityNew />;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7) {
    t9 = <div className="flex space-x-4 mb-4 md:mb-0">{t5}{t6}<StyledAccessibility onClick={t7} title={"Wy\u015Bwietl przycisk dost\u0119pno\u015Bci"}>{t8}</StyledAccessibility></div>;
    $[18] = t7;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="flex space-x-4"><Link href="/dostawa-i-platnosc" className="block w-20"><Image src={paynow} alt="Paynow" /></Link></div>;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t9) {
    t11 = <div className="mt-8 pt-6 border-t flex flex-col md:flex-row justify-between items-center">{t9}{t10}</div>;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t4) {
    t12 = <StyledFooter className="pb-6"><div className="relative max-w-screen-2xl mx-auto py-4 border-t pt-8 2xl:px-0 px-4">{t4}{t11}</div></StyledFooter>;
    $[23] = t11;
    $[24] = t4;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
};
export const FooterSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <footer className="pb-6 bg-white"><div className="relative max-w-screen-2xl mx-auto py-4 border-t pt-8 2xl:px-0 px-4"><div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">{[...Array(4)].map(_temp4)}</div></div></footer>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const StyledFooter = styled.footer`
  background-color: ${({
  theme
}) => theme.backgrounds.theme};
`;
export default Footer;
function _temp(link, index) {
  return <CustomLi key={index} className="list-none"><Link href={link.url} aria-label={link.title}><Text text={link.title} color={TextColor.GRAYSCALE_500} fontSize={TextSize.S} /></Link></CustomLi>;
}
function _temp2(link_0, index_0) {
  return <CustomLi key={index_0} className="list-none"><Link href={link_0.url} aria-label={link_0.title}><Text text={link_0.title} color={TextColor.GRAYSCALE_500} fontSize={TextSize.S} className="pb-1" /></Link></CustomLi>;
}
function _temp3(__0, i) {
  return <div key={i} className="h-3 bg-gray-200 rounded animate-pulse w-20 mt-2" />;
}
function _temp4(_, index) {
  return <div key={index} className="mb-8"><div className="h-4 bg-gray-200 rounded animate-pulse w-24 mb-4" /><div className="space-y-2 mt-4">{[...Array(4)].map(_temp3)}</div></div>;
}